import { useMutation, useQuery, useQueryClient } from 'react-query'
import { systemIssuesService } from '../../../services/systemIssuesService'
import type { SystemIssue } from '../types/system-issues'

export const resolutionSummariesKey = (issueId: number) =>
  ['system-issues', 'resolution-summaries', issueId] as const

/** Resumos da solução do chamado — só dev (o backend recusa os demais). */
export function useResolutionSummaries(issueId: number, enabled: boolean) {
  return useQuery(
    resolutionSummariesKey(issueId),
    () => systemIssuesService.listResolutionSummaries(issueId),
    { enabled, staleTime: 30 * 1000 },
  )
}

export function useSaveResolutionSummary(issueId: number) {
  const qc = useQueryClient()
  return useMutation(
    (summary: string) => systemIssuesService.saveResolutionSummary(issueId, summary),
    { onSuccess: () => qc.invalidateQueries(resolutionSummariesKey(issueId)) },
  )
}

/** Mesmo instante (o resumo guarda o `resolved_at` do chamado). */
export function sameResolution(a: string | null, b: string | null): boolean {
  return a != null && b != null && Date.parse(a) === Date.parse(b)
}

/** A resolução atual do chamado ainda não tem resumo. */
export function isSummaryMissing(
  issue: Pick<SystemIssue, 'status' | 'resolved_at'>,
  summaries: Array<{ resolved_at: string }>,
): boolean {
  return (
    issue.status === 'resolved' &&
    !summaries.some((s) => sameResolution(s.resolved_at, issue.resolved_at))
  )
}
